/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(() => ({
  root: {
    padding: Tokens.spacing['$sp-4']
  },
  moduleInfo: {
    marginTop: Tokens.spacing['$sp-4']
  },
  moduleName: {
    fontWeight: 'bold'
  }
}));
